/* eslint-disable */
import Alpine from "alpinejs";
import barba from "@barba/core";

class Barba {
  constructor() {
    this.initBarba();
  }

  initBarba() {
    barba.init({
      debug: false,
      cacheIgnore: false,
      prefetchIgnore: false,
      timeout: 5000,
      transitions: [
        {
          name: "default",
          leave({ current, next, trigger }) {
            current.container.classList.remove("barba-container--fadein");
            current.container.classList.toggle("barba-container--fadeout");
            const async = this.async();
            setTimeout(() => {
              async();
            }, 400);
          },
          enter({ current, next, trigger }) {
            window.scrollTo(0, 0);
            document.body.classList.remove("u-mobile-block-scroll"); // Remove scroll block
            next.container.classList.remove("barba-container--fadeout");
            next.container.classList.toggle("barba-container--fadein");
          },
        },
      ],
      prevent: ({ el }) => {
        const ignoreClasses = ["ab-item", "another-class-here"]; // Additional (besides .js-barba-prevent) ignore links with these classes (ab-item is for wp admin toolbar links)
        if (/.pdf/.test(el.href.toLowerCase())) {
          return true;
        }
        if (el.classList && el.classList.contains("js-barba-prevent")) {
          return true;
        }
        if (el.dataset && el.dataset.lightbox) {
          return true;
        }
        for (let i = 0; i < ignoreClasses.length; i++) {
          if (el.classList.contains(ignoreClasses[i])) {
            return true;
          }
        }
      },
      requestError: (trigger, action, url, response) => {
        console.log("REQUEST ERROR");
        console.log(url);
        console.log(response);
      },
    });
    // Global enter hook
    barba.hooks.enter(({ current, next, trigger }) => {
      window.scrollTo(0, 0);
      window.requestAnimationFrame(() => {
        this.setBodyClasses(next.container);
        this.setTranslationLinks(next.container);
        this.mobileMenu();
        this.updateCurrentHighlightedMenu(next.html);
        this.displayNavBar(document.location);

        // WP admin bar
        this.fixWpAdminBar();
      });
    });

    barba.hooks.after((data) => {
      this.getStylesAndScripts(data, () => {
        this.domReloadEvents();
      });
    });

    barba.hooks.afterLeave((data) => {
      this.reloadInlineScript(data);
    });
  }

  displayNavBar(d) {
    // Pass document object and check if we have to hide the admin bar or not.
    const navBarEl = document.getElementById("header-nav-bar");

    if (d.href.includes("/mailings") || d.href.includes("/tickets")) {
      navBarEl.classList.remove("md:block");
    } else {
      navBarEl.classList.add("md:block");
    }
  }

  reloadInlineScript(data) {
    const js = data.next.container.querySelectorAll("script.reload-on-ajax");
    [].forEach.call(js, function (script) {
      window.eval(script.innerHTML);
    });
  }

  getMultiScripts(res, callback) {
    const newImports = [];
    const newEvaluations = [];
    const scriptTags = res.getElementsByTagName("script");

    Array.from(scriptTags).forEach((s, i) => {
      const src = s.getAttribute("src");
      if (src) {
        // If not already initialized add it
        if (
          window.initializedScripts.indexOf(src) === -1 &&
          window.previouslyLoadedScripts.indexOf(src) === -1
        ) {
          newImports.push(src);
        }
      } else {
        const scriptsNotAllowed = ["__bs_script__"]; // Scripts ID to not be loaded.
        const mimesNotAllowed = ["application/ld+json", "text/x-jsrender"]; // Scripts MIME Type to not be added.
        const scriptType = s.getAttribute("type");
        const scriptId = s.getAttribute("id");

        if (
          scriptsNotAllowed.indexOf(scriptId) === -1 &&
          mimesNotAllowed.indexOf(scriptType) === -1
        ) {
          newEvaluations.push(s.innerHTML);
        }
      }
    });

    function loadScript(url) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.src = url;
        script.async = false;
        script.onload = () => {
          resolve(url);
        };
        script.onerror = () => {
          reject(url);
        };
        document.body.appendChild(script);
        window.previouslyLoadedScripts.push(url);
      });
    }

    // Save all Promises as array
    const promises = [];
    newImports.forEach((url) => {
      promises.push(loadScript(url));
    });

    Promise.all(promises)
      .then(() => {
        // First eval load inline scripts.
        if (newEvaluations.length > 0) {
          newEvaluations.forEach((s) => {
            window.eval(`${s}`); //eslint-disable-line
          });
        }
        callback();
      })
      .catch((script) => {
        console.error(`${script} failed to load`); // eslint-disable-line
      });
  }

  getMultiStyles(res) {
    const newImports = [];
    const stylesTags = res.querySelectorAll('link[rel^="stylesheet"]');
    Array.from(stylesTags).forEach((s, i) => {
      const href = s.getAttribute("href");
      if (href) {
        // if not already initialized add it
        if (window.initializedStyles.indexOf(href) === -1) {
          newImports.push(href);
        }
      }
    });
    const loadStyle = () => {
      if (newImports.length > 0) {
        const nextStyle = newImports.shift();
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.onload = () => {
          loadStyle();
        };
        link.href = nextStyle;
        const headScript = document.querySelector("script");
        headScript.parentNode.insertBefore(link, headScript);
      }
    };

    loadStyle();
  }

  getStylesAndScripts(data, callback) {
    // Convert HTML Raw data to HTML Element in order to parser it.
    const response = data.next.html.replace(
      /(<\/?)body( .+?)?>/gi,
      "$1notbody$2>",
      data.next.html
    );
    const parser = new DOMParser();
    const res = parser.parseFromString(response, "text/html");

    // Identify and load scripts and styles for the next page.
    this.getMultiScripts(res, callback);
    this.getMultiStyles(res);
  }

  domReloadEvents() {
    const loadEvent = document.createEvent("Event");

    // Trigger DOMContentLoaded event
    window.document.dispatchEvent(
      new Event("DOMContentLoaded", {
        bubbles: true,
        cancelable: true,
      })
    );

    // Trigger load event
    loadEvent.initEvent("load", false, false);
    window.dispatchEvent(loadEvent);
  }

  setBodyClasses(e) {
    const skipClasses = [""]; // Add the classes you want to skip
    const currentBodyClasses = document.querySelector("body").classList;
    const newBodyClasses = e.querySelector("#body-classes").value;
    const splittedNewBodyClasses = newBodyClasses.split(" ");
    for (var i = 0; i < currentBodyClasses.length; i += 1) {
      if (newBodyClasses.indexOf(currentBodyClasses[i]) > -1) {
        skipClasses.push(currentBodyClasses[i]);
      }
    }
    Array.from(currentBodyClasses).forEach((bodyClass) => {
      // Don't remove class if it exists in skipClasses
      if (!skipClasses.includes(bodyClass)) {
        currentBodyClasses.remove(bodyClass);
      }
    });
    for (let s = 0; s < splittedNewBodyClasses.length; s++) {
      document.querySelector("body").classList.add(splittedNewBodyClasses[s]);
    }
  }

  setTranslationLinks(e) {
    "use strict";
    const linksData = e.getAttribute("data-translation-links");
    if (linksData) {
      const links = JSON.parse(linksData);
      if (links.constructor === Array && links.length > 0) {
        for (let s = 0; s < links.length; s++) {
          const li = document.querySelector(
            ".header__languages ul li:nth-child(" + (s + 1) + ") a"
          );
          if (li !== null) {
            li.setAttribute("href", links[s]);
          }
        }
      }
    }
  }

  mobileMenu() {
    const mobileMenuToogler = document.getElementById("main-menu-toggler");
    if (mobileMenuToogler) {
      mobileMenuToogler.checked = false;
    }
  }

  /**
   * Parses the DOM structure of the BarbaJS fetch, and applies same classes on the header in DOM.
   * @param {String} htmlString - The new page html in string format from barbaJs
   */
  updateCurrentHighlightedMenu(htmlString) {
    const html = new window.DOMParser().parseFromString(
      htmlString,
      "text/html"
    );
    if ("body" in html === false || html.body.childNodes.length < 1) {
      // Why the length check?
      return;
    }
    // First remove current classes from all menu items and sub menus.
    for (const el of Array.from(document.querySelectorAll(".menu-item"))) {
      el.classList.remove("menu-item-tab-current");
      el.classList.add("menu-item-tab");
    }
    // Get the new current menu items and parents and set the appropiate classes.
    let newEl;
    for (const el of Array.from(
      html.querySelectorAll(".menu-item-tab-current")
    )) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.remove("menu-item-tab");
          newEl.classList.add("menu-item-tab-current");
        }
      }
    }

    // First remove current classes from all menu items and sub menus.
    for (const el of Array.from(
      document.querySelectorAll(".menu-item-mb-first ")
    )) {
      el.classList.remove("menu-item-mb-first-el-current");
      el.classList.add("menu-item-mb-first-el");
    }

    // Get the new current menu items and parents and set the appropiate classes.
    for (const el of Array.from(
      html.querySelectorAll(".menu-item-mb-first-el-current")
    )) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.remove("menu-item-mb-first-el");
          newEl.classList.add("menu-item-mb-first-el-current");
        }
      }
    }

    // First remove current classes from all menu items and sub menus.
    for (const el of Array.from(
      document.querySelectorAll(".menu-item-mb-second ")
    )) {
      el.classList.remove("menu-item-mb-second-el-current");
      el.classList.add("menu-item-mb-second-el");
    }

    // Get the new current menu items and parents and set the appropiate classes.
    for (const el of Array.from(
      html.querySelectorAll(".menu-item-mb-second-el-current")
    )) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.remove("menu-item-mb-second-el");
          newEl.classList.add("menu-item-mb-second-el-current");
        }
      }
    }
  }

  fixWpAdminBar() {
    if (!document.querySelector("#wpadminbar")) {
      return;
    }

    const xmlhttp = ajaxReq(); // eslint-disable-line
    const url = encodeURI(scripts_ajax_variables.ajax_url); // eslint-disable-line
    const params =
      "action=hs_fix_barbajs_wp_admin&location=" + window.location.href;

    xmlhttp.open("POST", url, true); // set true for async, false for sync request
    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    xmlhttp.send(params); // or null, if no parameters are passed
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        try {
          var response = JSON.parse(xmlhttp.responseText);
          if (response && response.success === true) {
            const adminMenuLinks = Array.from(
              document.querySelector(".ab-top-menu").querySelectorAll("a")
            );
            for (const adminLink of adminMenuLinks) {
              const mregex = /post=(\d+)&/g;
              adminLink.classList.add("js-barba-prevent");
              const href = adminLink.getAttribute("href");
              const groups = mregex.exec(href);
              if (groups && groups.length >= 2) {
                adminLink.setAttribute(
                  "href",
                  href.replace(groups[1], response.pageId)
                );
              } else {
                const chunks = href.split("?url=");
                if (chunks.length === 2) {
                  adminLink.setAttribute(
                    "href",
                    chunks[0] +
                      "?url=" +
                      encodeURIComponent(window.location.href)
                  );
                }
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
  }
}

export default Barba;
